import { render, staticRenderFns } from "./UnAuthLayout.vue?vue&type=template&id=47f179e3&"
import script from "./UnAuthLayout.vue?vue&type=script&lang=js&"
export * from "./UnAuthLayout.vue?vue&type=script&lang=js&"
import style0 from "./UnAuthLayout.vue?vue&type=style&index=0&id=47f179e3&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports